import { Box, IconButton, Stack, ToggleButton, ToggleButtonGroup, Paper } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export function FinancialPeriodFilter({
  selectedDate,
  onChange,
  viewByYear,
  onToggleViewByYear,
  viewAllPeriod,
  onToggleViewAllPeriod,
}) {
  // O período selecionado é derivado das próprias flags, e não de um estado
  // local: guardar em paralelo deixava o filtro abrir sem nenhum botão marcado,
  // mesmo com a tela já mostrando o mês corrente.
  const selectedPeriod = (() => {
    if (viewAllPeriod) return 'all';
    if (viewByYear) return 'year';
    return 'month';
  })();

  const handlePeriodChange = (value) => {
    if (!value) return;

    onToggleViewByYear(value === 'year');
    onToggleViewAllPeriod(value === 'all');
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 3,
        bgcolor: 'background.default',
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        {/* Toggle Mês / Ano */}
        <ToggleButtonGroup
          exclusive
          size="small"
          value={selectedPeriod}
          onChange={(_, value) => handlePeriodChange(value)}
        >
          <ToggleButton value="month">Mês</ToggleButton>
          <ToggleButton value="year">Ano</ToggleButton>
          <ToggleButton value="all">Todo Histórico</ToggleButton>
        </ToggleButtonGroup>

        {/* Navegação + DatePicker */}
        <Stack direction="row" spacing={1} alignItems="center">
          <IconButton
            size="small"
            disabled={viewByYear || viewAllPeriod}
            onClick={() => onChange(selectedDate.subtract(1, 'month'))}
          >
            <ChevronLeft size={18} />
          </IconButton>

          <DatePicker
            disabled={viewAllPeriod}
            views={viewByYear ? ['year'] : ['month', 'year']}
            value={selectedDate}
            onChange={(date) => date && onChange(date)}
            slotProps={{
              textField: {
                size: 'small',
                sx: { width: 180 },
              },
            }}
          />

          <IconButton
            size="small"
            disabled={viewByYear || viewAllPeriod}
            onClick={() => onChange(selectedDate.add(1, 'month'))}
          >
            <ChevronRight size={18} />
          </IconButton>
        </Stack>
      </Stack>
    </Paper>
  );
}
